import { DEFAULT_NUMBER } from './defaultValues';
export const FALLBACK_REQUESTS_COUNT = 478900;
export const FALLBACK_CHECKLISTS_COUNT = 1225200;
export const FALLBACK_USERS_COUNT = 59140;

export class CustomStatisticsResponse {
	constructor(axiosResponse) {
		this.response = axiosResponse;

		this.requests = this.response?.data?.requests || FALLBACK_REQUESTS_COUNT;
		this.checklists = this.response?.data?.checklists || FALLBACK_CHECKLISTS_COUNT;
		this.messages = this.response?.data?.messages || DEFAULT_NUMBER;
		this.total_users = this.response?.data?.total_users || FALLBACK_USERS_COUNT;
	}
}
